import * as React from 'react';
import { Button } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { KeyValueList, Panel } from '../ui';
import { AAV_LINK } from '../../constants';

/** "Jane Doe " → "Jane-Doe" for the public story URL. */
const formatString = (value: string) => value.trim().replace(/\s+/g, '-');

/** Read-only author facts of a story, with the public story link when the story is published. */
export default function AuthorForm(props: any) {
    const { data } = props.data;
    const storyLink = data.isPublished === 1 && AAV_LINK ? `${AAV_LINK}pages/${formatString(data.firstName || '')}-${data.storyId}` : null;

    return (
        <Panel
            title="Author"
            actions={storyLink ? (
                <Button variant="outlined" size="small" startIcon={<OpenInNewIcon />} component="a" href={storyLink} target="_blank" rel="noreferrer">
                    Open public story
                </Button>
            ) : undefined}
        >
            <KeyValueList
                minColumnWidth={160}
                items={[
                    { label: 'Name', value: data.firstName },
                    { label: 'Email', value: data.email },
                    { label: 'Author ID', value: data.authorId, mono: true },
                    { label: 'Shopify customer ID', value: data.shopifyId, mono: true },
                    { label: 'Referral link', value: data.refferalLink, mono: true },
                    { label: 'Rewards', value: data.rewards },
                ]}
            />
        </Panel>
    );
}
